import React from "react";

/**
 * HealthRing — ring pieno che circonda contenuto (logo/icona).
 * Puro SVG, no dependency.
 *
 * Modalità:
 *  - variant="around": ring 96×96 (o size prop) da usare attorno a logo cliente
 *  - variant="hero":   ring 168×168 grande per hero cliente
 *
 * Colori solidi (verde/ambra/rosso) da token dashboard.
 */
const COLOR_MAP = {
    green: "#16A34A",
    amber: "#F59E0B",
    red: "#DC2626",
};

export default function HealthRing({
    color = "green",
    size = 96,
    stroke = 5,
    children = null,
    ariaLabel,
    "data-testid": testid = "health-ring",
}) {
    const stroked = COLOR_MAP[color] || COLOR_MAP.green;
    const cx = size / 2;
    const cy = size / 2;
    const r = (size - stroke) / 2;
    return (
        <div
            role="img"
            aria-label={ariaLabel || `stato ${color}`}
            data-testid={testid}
            data-health-color={color}
            style={{ position: "relative", width: size, height: size, display: "inline-block" }}
        >
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}
                 style={{ display: "block" }}>
                {/* faint track */}
                <circle cx={cx} cy={cy} r={r} fill="none" stroke="#F1F5F9" strokeWidth={stroke} />
                {/* colored ring */}
                <circle
                    cx={cx} cy={cy} r={r}
                    fill="none" stroke={stroked} strokeWidth={stroke}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${cx} ${cy})`}
                />
            </svg>
            {children != null && (
                <div style={{
                    position: "absolute",
                    inset: stroke + 4,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>{children}</div>
            )}
        </div>
    );
}
